





















import CouponItem from '@/components/common/CouponItem.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import DeleteCouponPopup from '@/components/common/DeleteCouponPopup.vue'

@Component({
  components: {
    CouponItem,
    DeleteCouponPopup
  }
})
export default class Coupons extends Vue {
  public query = ''
  public limit = 100
  public offset = 0
  public brandId = 0
  public actionCoupon: any = null
  public coupons: any[] = []
  public totalCount = 0
  public busy: boolean = false
  public product: {name: string, section: string, description:string, images: any[]} = {
    name: '',
    section: '',
    description: '',
    images: []
  }
  public productDetails: object = {}
  public QuestionDataExistsInLocalStorage: any = ''
  public DataExistsInLocalStorage: boolean = false
  public draftCoupon: any = ''

  deleteDraft () {
    localStorage.removeItem('CouponBasicDetails')
    localStorage.removeItem('CouponQuestionDetails')
    this.coupons = []
    this.getGlobalCoupons()
    this.DataExistsInLocalStorage = false
    this.$notify({ type: 'success', text: 'Draft insight has been deleted successfully!' })
  }

  redirectToCreateCouponPage () {
    this.$router.push('/brand/coupon/create?filldraft=true')
  }
  getGlobalCoupons (clear = true) {
    this.busy = true
    this.$store.dispatch('getGlobalCoupons', { query: this.query, limit: this.limit, offset: this.offset, brandId: this.brandId }).then((response) => {
      if (response.options.query === this.query && response.options.limit === this.limit && this.offset === response.options.offset) {
        if (clear) this.coupons = []
        this.coupons.push(...response.response.body.coupons)
        this.totalCount = response.response.body.count
        this.busy = false
      }
    }, (response) => {
      this.busy = false
    })
  }
  checkLocalStorageForBasicDetails () {
    let localStorageBasicDetails = localStorage.getItem('CouponBasicDetails')
    if (localStorageBasicDetails !== null) {
      this.DataExistsInLocalStorage = true
      let data = localStorage.getItem('CouponBasicDetails')
      if (data !== null) {
        this.draftCoupon = JSON.parse(data)
      }
      console.log(this.draftCoupon)
    }
  }

  loadMore () {
    this.$data.offset += this.$data.limit
    this.getGlobalCoupons(false)
  }

  @Watch('query')
  onSearch () {
    Vue.common.delay(() => {
      this.offset = 0
      this.getGlobalCoupons()
    }, 500)()
  }

  created () {
    this.brandId = this.$store.state.userData.brandId
    this.$store.dispatch('getAppSettingsKeyValuePair').then(() => {
      this.checkLocalStorageForBasicDetails()
      this.getGlobalCoupons()
    })
  }

  refresh () {
    this.offset = 0
    this.getGlobalCoupons()
  }

  editProductDetails (product:object) {
    this.productDetails = product
  }

  get hasLoadMore (): boolean {
    return this.coupons.length < this.totalCount
  }
}
